// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: -webkit-sticky;
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.-top-3 {
  top: -0.75rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.top-4 {
  top: 1rem;
}
.top-full {
  top: 100%;
}
.z-0 {
  z-index: 0;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.m-4 {
  margin: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-7 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-6 {
  height: 1.5rem;
}
.h-80 {
  height: 20rem;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[196px\\] {
  height: 196px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[260px\\] {
  height: 260px;
}
.h-\\[370px\\] {
  height: 370px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.max-h-5 {
  max-height: 1.25rem;
}
.min-h-5 {
  min-height: 1.25rem;
}
.w-12 {
  width: 3rem;
}
.w-24 {
  width: 6rem;
}
.w-3 {
  width: 0.75rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[306px\\] {
  width: 306px;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -webkit-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-5 {
  min-width: 1.25rem;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-full {
  min-width: 100%;
}
.max-w-5 {
  max-width: 1.25rem;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[306px\\] {
  max-width: 306px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[410px\\] {
  max-width: 410px;
}
.max-w-\\[570px\\] {
  max-width: 570px;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.border-collapse {
  border-collapse: collapse;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.appearance-none {
  -webkit-appearance: none;
          appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.gap-\\[30px\\] {
  gap: 30px;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.overflow-x-auto {
  overflow-x: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-e-lg {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.rounded-s-lg {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.rounded-t-\\[20px\\] {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-\\[\\#58C3A8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(88 195 168 / 1);
  border-color: rgb(88 195 168 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BDBDBD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(189 189 189 / 1);
  border-color: rgb(189 189 189 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C4C4C4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(196 196 196 / 1);
  border-color: rgb(196 196 196 / var(--tw-border-opacity, 1));
}
.border-\\[\\#DC1D1D\\] {
  --tw-border-opacity: 1;
  border-color: rgb(220 29 29 / 1);
  border-color: rgb(220 29 29 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E11F60\\] {
  --tw-border-opacity: 1;
  border-color: rgb(225 31 96 / 1);
  border-color: rgb(225 31 96 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E5E5E5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / 1);
  border-color: rgb(229 229 229 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E62929\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 41 41 / 1);
  border-color: rgb(230 41 41 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EA2466\\] {
  --tw-border-opacity: 1;
  border-color: rgb(234 36 102 / 1);
  border-color: rgb(234 36 102 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EFAF2D\\] {
  --tw-border-opacity: 1;
  border-color: rgb(239 175 45 / 1);
  border-color: rgb(239 175 45 / var(--tw-border-opacity, 1));
}
.border-\\[\\#a9275380\\] {
  border-color: #a9275380;
}
.border-\\[\\#e5e5e5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 229 229 / 1);
  border-color: rgb(229 229 229 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / 1);
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / 1);
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / 1);
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#D9D9D9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / 1);
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3F3F3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 243 243 / 1);
  background-color: rgb(243 243 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7F7F7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / 1);
  background-color: rgb(247 247 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF4F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 244 248 / 1);
  background-color: rgb(255 244 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f7f7f7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / 1);
  background-color: rgb(247 247 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / 1);
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / 1);
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / 1);
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / 1);
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / 1);
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#FF4885\\] {
  --tw-gradient-from: #FF4885 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 72 133 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50 {
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#EA24BF\\] {
  --tw-gradient-to: #EA24BF var(--tw-gradient-to-position);
}
.to-indigo-50 {
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.bg-contain {
  background-size: contain;
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[15px\\] {
  padding: 15px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-feature-settings: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-6 {
  line-height: 1.5rem;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.text-\\[\\#09CB11\\] {
  --tw-text-opacity: 1;
  color: rgb(9 203 17 / 1);
  color: rgb(9 203 17 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1B2495\\] {
  --tw-text-opacity: 1;
  color: rgb(27 36 149 / 1);
  color: rgb(27 36 149 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1E1E1E\\] {
  --tw-text-opacity: 1;
  color: rgb(30 30 30 / 1);
  color: rgb(30 30 30 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e1e1e\\] {
  --tw-text-opacity: 1;
  color: rgb(30 30 30 / 1);
  color: rgb(30 30 30 / var(--tw-text-opacity, 1));
}
.text-\\[\\#464646\\] {
  --tw-text-opacity: 1;
  color: rgb(70 70 70 / 1);
  color: rgb(70 70 70 / var(--tw-text-opacity, 1));
}
.text-\\[\\#58C3A8\\] {
  --tw-text-opacity: 1;
  color: rgb(88 195 168 / 1);
  color: rgb(88 195 168 / var(--tw-text-opacity, 1));
}
.text-\\[\\#DC1D1D\\] {
  --tw-text-opacity: 1;
  color: rgb(220 29 29 / 1);
  color: rgb(220 29 29 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E62929\\] {
  --tw-text-opacity: 1;
  color: rgb(230 41 41 / 1);
  color: rgb(230 41 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EA2466\\] {
  --tw-text-opacity: 1;
  color: rgb(234 36 102 / 1);
  color: rgb(234 36 102 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EFAF2D\\] {
  --tw-text-opacity: 1;
  color: rgb(239 175 45 / 1);
  color: rgb(239 175 45 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / 1);
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / 1);
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / 1);
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / 1);
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / 1);
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / 1);
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / 1);
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / 1);
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / 1);
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / 1);
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / 1);
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / 1);
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}
.no-underline {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.placeholder-\\[\\#20244E\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(32 36 78 / 1);
  color: rgb(32 36 78 / var(--tw-placeholder-opacity, 1));
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-55 {
  opacity: 0.55;
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-lg {
  --tw-drop-shadow: drop-shadow(0 10px 8px rgb(0 0 0 / 0.04)) drop-shadow(0 4px 3px rgb(0 0 0 / 0.1));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
:root {
  --main-text: #333333;
  --main-button: #FF5733;
  --main-checkbox: #28A745;
  --rewards-text: #0056b3;
  --rewards-button: #FFC107;
  --rewards-checkbox: #17A2B8;
  --sib-text: #444444;
  --sib-button: #6610f2;
  --sib-checkbox: #dc3545;
  --kotak-text: #ea1939;
  --kotak-button: #ea1939;
  --kotak-checkbox: #ea1939;
  --primary-font-Inter: "Inter", sans-serif;
  --primary-font-Inter-Tight: "Inter Tight", sans-serif;
  --primary-font-DM-Sans: "DM Sans", sans-serif;
}

html,
body,
#root {
  min-height: 100%;
}

.appShell {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.appShellContent {
  flex: 1 0 auto;
  min-width: 0;
}

.font-Inter {
  font-family: "Inter", sans-serif !important;
  font-family: var(--primary-font-Inter) !important;
}

.font-Inter-Tight {
  font-family: "Inter Tight", sans-serif !important;
  font-family: var(--primary-font-Inter-Tight) !important;
}

.font-DM-Sans {
  font-family: "DM Sans", sans-serif !important;
  font-family: var(--primary-font-DM-Sans) !important;
}

.no-scroll {
  overflow-y: hidden !important;
}

.creditCardInput input {
  height: 60px;
}

.whatsNewRibbon {
  --r: .8em;
  padding-right: calc(var(--r) + 0.25em);
  -webkit-clip-path: polygon(-100vw 0, calc(100% - var(--r)) 0, 100% 50%, calc(100% - var(--r)) 100%, -100vw 100%);
          clip-path: polygon(-100vw 0, calc(100% - var(--r)) 0, 100% 50%, calc(100% - var(--r)) 100%, -100vw 100%);
}

.similarMemberRecommendedOffer .carousel-custom-arrow {
  position: absolute;
  top: -55px;
  right: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
}
.similarMemberRecommendedOffer .left-arrow {
  right: 55px !important;
}
.similarMemberRecommendedOffer .right-arrow {
  right: 20px !important;
}
.similarMemberRecommendedOffer .carousel-custom-arrow.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F7F7F7;
}

.scrollbar::-webkit-scrollbar {
  height: 5px;
  background-color: #F7F7F7;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #636363;
}

.htmlRenderCode ul, .htmlRenderCode ol {
  list-style-position: inside;
}
.htmlRenderCode ul {
  list-style-type: disc;
}
.htmlRenderCode ol {
  list-style-type: decimal;
}

.carousel-custom-arrow {
  position: absolute;
  top: 2px;
  right: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  z-index: 1;
}

.leftArrow {
  right: 60px;
}
@media screen and (max-width: 767px) {
  .leftArrow {
    right: 40px;
  }
}

.rightArrow {
  right: 20px;
}
@media screen and (max-width: 767px) {
  .rightArrow {
    right: 0;
  }
}

.left-arrow {
  right: 60px;
}
@media (max-width: 768px) {
  .left-arrow {
    right: 55px;
  }
}

.right-arrow {
  right: 20px;
}

.carousel-custom-arrow.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.carousel-wrapper {
  margin-top: 1rem;
}

.loyaltyCard {
  transition: all 0.3s ease;
  position: relative;
  overflow: visible;
}

.loyaltyCard:hover {
  transform: translateY(-4px);
}

.loyaltyCard .card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
}

@media (max-width: 767px) {
  .loyaltyCard {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}
.similarSubscription {
  height: 230px;
  overflow: hidden;
}

.travelScroll {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.travelScroll::-webkit-scrollbar {
  display: none;
}

/* Banner Styles for Swiper Implementation */
.midBanner {
  height: 320px;
  width: 100%;
  overflow: hidden;
  position: relative;
}

@media (max-width: 768px) {
  .midBanner {
    height: 200px !important;
  }
}
.banner-swiper .swiper-pagination-bullet {
  width: 10px;
  height: 8px;
  background: rgba(30, 30, 30, 0.47);
  border-radius: 10px;
  opacity: 1;
  transition: all 0.3s ease;
  margin: 0 4px;
}

.banner-swiper .swiper-pagination-bullet-active {
  width: 32px;
  background: #1E1E1E;
}

.banner-swiper .swiper-slide {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 767px) {
  .blurBackground {
    overflow: hidden;
    position: relative;
  }
  .blurBackground:before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    z-index: 99;
  }
}

.blurDefaultBackground {
  overflow: hidden;
  position: relative;
}
.blurDefaultBackground:before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  z-index: 9999;
}

.redemptionSteps ol {
  list-style: decimal;
  margin-left: 20px;
}
.redemptionSteps ul {
  list-style: disc;
  margin-left: 20px;
}

/* Turnstile Mobile Responsive Styles */
.turnstile-widget-container {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Target the Turnstile iframe and widget elements */
.turnstile-widget-container > div,
.turnstile-widget-container iframe {
  max-width: 100% !important;
  width: 100% !important;
}

/* Mobile responsive scaling */
@media (max-width: 768px) {
  .turnstile-widget-container {
    transform-origin: left center;
  }
  .turnstile-widget-container > div {
    transform-origin: left center;
    transform: scale(0.95);
  }
}
@media (max-width: 640px) {
  .turnstile-widget-container > div {
    transform-origin: left center;
    transform: scale(0.9);
  }
}
@media (max-width: 480px) {
  .turnstile-widget-container > div {
    transform-origin: left center;
    transform: scale(0.87);
  }
}
@media (max-width: 400px) {
  .turnstile-widget-container > div {
    transform-origin: left center;
    transform: scale(0.85);
  }
}
@media (max-width: 360px) {
  .turnstile-widget-container > div {
    transform-origin: left center;
    transform: scale(0.8);
  }
}
/* Handle very small screens */
@media (max-width: 320px) {
  .turnstile-widget-container > div {
    transform: scale(0.7);
  }
}
.placeholder-shown\\:font-normal:placeholder-shown {
  font-weight: 400;
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / 1);
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / 1);
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / 1);
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
@media (min-width: 640px) {

  .sm\\:h-\\[260px\\] {
    height: 260px;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:gap-8 {
    gap: 2rem;
  }

  .sm\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 768px) {

  .md\\:bottom-14 {
    bottom: 3.5rem;
  }

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mb-20 {
    margin-bottom: 5rem;
  }

  .md\\:mr-0 {
    margin-right: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-\\[140px\\] {
    width: 140px;
  }

  .md\\:w-\\[410px\\] {
    width: 410px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-\\[410px\\] {
    max-width: 410px;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:border-b {
    border-bottom-width: 1px;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .md\\:pt-7 {
    padding-top: 1.75rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:leading-5 {
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:sticky {
    position: -webkit-sticky;
    position: sticky;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:max-w-\\[368px\\] {
    max-width: 368px;
  }

  .lg\\:max-w-full {
    max-width: 100%;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:py-9 {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}
@media (min-width: 1280px) {

  .xl\\:block {
    display: block;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:max-w-full {
    max-width: 100%;
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/CommonScss/style.scss","webpack://./src/Styles/_colors.scss","webpack://./src/Styles/_mixins.scss"],"names":[],"mappings":"AACA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA,CAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;AACA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,qCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,6IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,yBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;UAAA;AAAA;AAAA;EAAA,kCAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA,kDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,wKAAA;EAAA,wJAAA;EAAA,gNAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,uGAAA;EAAA,+FAAA;EAAA,8HAAA;EAAA,wDAAA;EAAA;AAAA;AAEA;EACE,oBAAA;EACA,sBAAA;EACA,wBAAA;EAEA,uBAAA;EACA,yBAAA;EACA,2BAAA;EAEA,mBAAA;EACA,qBAAA;EACA,uBAAA;EAEA,qBAAA;EACA,uBAAA;EACA,yBAAA;EAEA,yCAAA;EACA,qDAAA;EACA,6CAAA;AALF;;AAQA;;;EAGE,gBAAA;AALF;;AAQA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AALF;;AAQA;EACE,cAAA;EACA,YAAA;AALF;;AAQA;EACE,2CAAA;EAAA,iDAAA;AALF;;AAQA;EACE,iDAAA;EAAA,uDAAA;AALF;;AAQA;EACE,6CAAA;EAAA,mDAAA;AALF;;AAQA;EACE,6BAAA;AALF;;AAUE;EACE,YAAA;AAPJ;;AAYA;EACE,SAAA;EACA,sCAAA;EACA,gHAAA;UAAA,wGAAA;AATF;;AAaE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAVJ;AAaE;EACE,sBAAA;AAXJ;AAcE;EACE,sBAAA;AAZJ;AAeE;EACE,mBAAA;EACA,YAAA;AAbJ;;AA4BA;EACE,oDAAA;EACA,mBAAA;EACA,yBC7FgB;ADoElB;;AA4BA;EACE,WAAA;EACA,yBClGgB;ADyElB;;AA4BA;EACE,mBAAA;EACA,oDAAA;EACA,yBAAA;AAzBF;;AA6BE;EACE,2BAAA;AA1BJ;AA6BE;EACE,qBAAA;AA3BJ;AA8BE;EACE,wBAAA;AA5BJ;;AAiCA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AA9BF;;AAiCA;EACE,WAAA;AA9BF;AAgCE;EAHF;IAII,WAAA;EA7BF;AACF;;AAgCA;EACE,WAAA;AA7BF;AA+BE;EAHF;IAII,QAAA;EA5BF;AACF;;AA+BA;EACE,WAAA;AA5BF;AElIE;EF6JF;IAII,WAAA;EA3BF;AACF;;AA8BA;EACE,WAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,YAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;AA3BF;;AA8BA;EACE,2BAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,QAAA;EACA,oCAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE;IACE,yCAAA;EA3BF;AACF;AA8BA;EACE,aAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,qBAAA;EACA,wBAAA;AA5BF;;AA+BA;EACE,aAAA;AA5BF;;AA+BA,4CAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA5BF;;AA+BA;EACE;IACE,wBAAA;EA5BF;AACF;AA+BA;EACE,WAAA;EACA,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,mBC5NY;AD+Ld;;AAgCA;EACE,aAAA;EACA,uBAAA;AA7BF;;AAkCE;EADF;IAEI,gBAAA;IACA,kBAAA;EA9BF;EAgCE;IACE,WAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,8BAAA;IACA,mCAAA;YAAA,2BAAA;IACA,WAAA;EA9BJ;AACF;;AAkCA;EACE,gBAAA;EACA,kBAAA;AA/BF;AAiCE;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mCAAA;UAAA,2BAAA;EACA,aAAA;AA/BJ;;AAoCE;EACE,mBAAA;EACA,iBAAA;AAjCJ;AAoCE;EACE,gBAAA;EACA,iBAAA;AAlCJ;;AAsCA,uCAAA;AACA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnCF;;AAsCA,oDAAA;AACA;;EAEE,0BAAA;EACA,sBAAA;AAnCF;;AAsCA,8BAAA;AACA;EACE;IACE,6BAAA;EAnCF;EAsCA;IACE,6BAAA;IACA,sBAAA;EApCF;AACF;AAuCA;EACE;IACE,6BAAA;IACA,qBAAA;EArCF;AACF;AAwCA;EACE;IACE,6BAAA;IACA,sBAAA;EAtCF;AACF;AAyCA;EACE;IACE,6BAAA;IACA,sBAAA;EAvCF;AACF;AA0CA;EACE;IACE,6BAAA;IACA,qBAAA;EAxCF;AACF;AA2CA,8BAAA;AACA;EACE;IACE,qBAAA;EAzCF;AACF;AAzUA;EAAA;AAyUA;AAzUA;EAAA,kBAyUA;EAzUA,sCAyUA;EAzUA;AAyUA;AAzUA;EAAA,kBAyUA;EAzUA,sCAyUA;EAzUA;AAyUA;AAzUA;EAAA,oBAyUA;EAzUA,wBAyUA;EAzUA;AAyUA;AAzUA;EAAA,8BAyUA;EAzUA;AAyUA;AAzUA;;EAAA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA,qBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,iBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,iBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,eAyUA;IAzUA;EAyUA;;EAzUA;IAAA,kBAyUA;IAzUA;EAyUA;AAAA;AAzUA;;EAAA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA,mBAyUA;IAzUA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA,qBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,oBAyUA;IAzUA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA,iBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,kBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,eAyUA;IAzUA;EAyUA;;EAzUA;IAAA,mBAyUA;IAzUA;EAyUA;;EAzUA;IAAA;EAyUA;AAAA;AAzUA;;EAAA;IAAA,wBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,gBAyUA;IAzUA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA,oBAyUA;IAzUA;EAyUA;;EAzUA;IAAA,mBAyUA;IAzUA;EAyUA;AAAA;AAzUA;;EAAA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;;EAzUA;IAAA;EAyUA;AAAA","sourcesContent":["@import \"src/Styles/theme.scss\";\n@tailwind base;\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n:root {\n  --main-text: #333333;\n  --main-button: #FF5733;\n  --main-checkbox: #28A745;\r\n\r\n  --rewards-text: #0056b3;\r\n  --rewards-button: #FFC107;\r\n  --rewards-checkbox: #17A2B8;\r\n\r\n  --sib-text: #444444;\r\n  --sib-button: #6610f2;\r\n  --sib-checkbox: #dc3545;\r\n\r\n  --kotak-text: #ea1939;\r\n  --kotak-button: #ea1939;\r\n  --kotak-checkbox: #ea1939;\r\n\r\n  --primary-font-Inter: \"Inter\", sans-serif;\r\n  --primary-font-Inter-Tight: \"Inter Tight\", sans-serif;\r\n  --primary-font-DM-Sans: \"DM Sans\", sans-serif;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\n.appShell {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n}\n\n.appShellContent {\n  flex: 1 0 auto;\n  min-width: 0;\n}\n\n.font-Inter {\n  font-family: var(--primary-font-Inter) !important;\n}\n\r\n.font-Inter-Tight {\r\n  font-family: var(--primary-font-Inter-Tight) !important;\r\n}\r\n\r\n.font-DM-Sans {\r\n  font-family: var(--primary-font-DM-Sans) !important;\r\n}\r\n\r\n.no-scroll {\r\n  overflow-y: hidden !important;\r\n}\r\n\r\n// creditcard input\r\n.creditCardInput {\r\n  input {\r\n    height: 60px;\r\n  }\r\n}\r\n\r\n// ribbon design \r\n.whatsNewRibbon {\r\n  --r: .8em;\r\n  padding-right: calc(var(--r) + .25em);\r\n  clip-path: polygon(-100vw 0, calc(100% - var(--r)) 0, 100% 50%, calc(100% - var(--r)) 100%, -100vw 100%);\r\n}\r\n\r\n.similarMemberRecommendedOffer {\r\n  .carousel-custom-arrow {\r\n    position: absolute;\r\n    top: -55px;\r\n    right: 0;\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    z-index: 1;\r\n  }\r\n\r\n  .left-arrow {\r\n    right: 55px !important;\r\n  }\r\n\r\n  .right-arrow {\r\n    right: 20px !important;\r\n  }\r\n\r\n  .carousel-custom-arrow.disabled {\r\n    cursor: not-allowed;\r\n    opacity: 0.5;\r\n  }\r\n}\r\n\r\n// .experiencesRewardDetail {\r\n//   .whatBenefitCard {\r\n//     width: 100%;\r\n//     max-width: 780px;\r\n//   }\r\n\r\n//   .whatBenefitSingleCard {\r\n//     width: 320px;\r\n//   }\r\n// }\r\n\r\n.scrollbar::-webkit-scrollbar-track {\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  border-radius: 10px;\r\n  background-color: $bg-light-grey-2;\r\n}\r\n\r\n.scrollbar::-webkit-scrollbar {\r\n  height: 5px;\r\n  background-color: $bg-light-grey-2;\r\n}\r\n\r\n.scrollbar::-webkit-scrollbar-thumb {\r\n  border-radius: 10px;\r\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\r\n  background-color: #636363;\r\n}\r\n\r\n.htmlRenderCode {\r\n  ul, ol {\r\n    list-style-position: inside;\r\n  }\r\n\r\n  ul {\r\n    list-style-type: disc;\r\n  }\r\n\r\n  ol {\r\n    list-style-type: decimal;\r\n  }\r\n}\r\n\r\n// React Multi-carousal custom arrow styling\r\n.carousel-custom-arrow {\r\n  position: absolute;\r\n  top: 2px;\r\n  right: 0;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n}\r\n\r\n.leftArrow {\r\n  right: 60px;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    right: 40px;\r\n  }\r\n}\r\n\r\n.rightArrow {\r\n  right: 20px;\r\n\r\n  @media screen and (max-width: 767px) {\r\n    right: 0;\r\n  }\r\n}\r\n\r\n.left-arrow {\r\n  right: 60px;\r\n\r\n  @include respond-md {\r\n    right: 55px;\r\n  }\r\n}\r\n\r\n.right-arrow {\r\n  right: 20px;\r\n}\r\n\r\n.carousel-custom-arrow.disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.carousel-wrapper {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.loyaltyCard {\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: visible;\r\n}\r\n\r\n.loyaltyCard:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.loyaltyCard .card-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(255, 255, 255, 0.1);\r\n  border-radius: 20px;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .loyaltyCard {\r\n    box-shadow: 0 4px 12px $color-border;\r\n  }\r\n}\r\n\r\n.similarSubscription {\r\n  height: 230px;\r\n  overflow: hidden;\r\n}\r\n\r\n.travelScroll {\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n.travelScroll::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n/* Banner Styles for Swiper Implementation */\r\n.midBanner {\r\n  height: 320px;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .midBanner {\r\n    height: 200px !important;\r\n  }\r\n}\r\n\r\n.banner-swiper .swiper-pagination-bullet {\r\n  width: 10px;\r\n  height: 8px;\r\n  background: rgba(30, 30, 30, 0.47);\r\n  border-radius: 10px;\r\n  opacity: 1;\r\n  transition: all 0.3s ease;\r\n  margin: 0 4px;\r\n}\r\n\r\n.banner-swiper .swiper-pagination-bullet-active {\r\n  width: 32px;\r\n  background: $stroke-dark;\r\n}\r\n\r\n.banner-swiper .swiper-slide {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n// Blur background when modal is open\r\n.blurBackground {\r\n  @media screen and (max-width: 767px) {\r\n    overflow: hidden;\r\n    position: relative;\r\n\r\n    &:before {\r\n      content: '';\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: 100%;\r\n      background: rgba(0, 0, 0, 0.4); // Dark overlay effect\r\n      backdrop-filter: blur(10px); // Blur effect\r\n      z-index: 99; // Ensure it appears above other content\r\n    }\r\n  }\r\n}\r\n\r\n.blurDefaultBackground {\r\n  overflow: hidden;\r\n  position: relative;\r\n\r\n  &:before {\r\n    content: '';\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: rgba(0, 0, 0, 0.4); // Dark overlay effect\r\n    backdrop-filter: blur(10px); // Blur effect\r\n    z-index: 9999; // Ensure it appears above other content\r\n  }\r\n}\r\n\r\n.redemptionSteps {\r\n  ol {\r\n    list-style: decimal;\r\n    margin-left: 20px;\r\n  }\r\n  \r\n  ul {\r\n    list-style: disc;\r\n    margin-left: 20px;\r\n  }\r\n}\r\n\r\n/* Turnstile Mobile Responsive Styles */\r\n.turnstile-widget-container {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  overflow: hidden;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Target the Turnstile iframe and widget elements */\r\n.turnstile-widget-container > div,\r\n.turnstile-widget-container iframe {\r\n  max-width: 100% !important;\r\n  width: 100% !important;\r\n}\r\n\r\n/* Mobile responsive scaling */\r\n@media (max-width: 768px) {\r\n  .turnstile-widget-container {\r\n    transform-origin: left center;\r\n  }\r\n  \r\n  .turnstile-widget-container > div {\r\n    transform-origin: left center;\r\n    transform: scale(0.95);\r\n  }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .turnstile-widget-container > div {\r\n    transform-origin: left center;\r\n    transform: scale(0.9);\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .turnstile-widget-container > div {\r\n    transform-origin: left center;\r\n    transform: scale(0.87);\r\n  }\r\n}\r\n\r\n@media (max-width: 400px) {\r\n  .turnstile-widget-container > div {\r\n    transform-origin: left center;\r\n    transform: scale(0.85);\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .turnstile-widget-container > div {\r\n    transform-origin: left center;\r\n    transform: scale(0.8);\r\n  }\r\n}\r\n\r\n/* Handle very small screens */\r\n@media (max-width: 320px) {\r\n  .turnstile-widget-container > div {\r\n    transform: scale(0.7);\r\n  }\r\n}\n","// ====================================\n// 🎨 Color Variables\n// ====================================\n\n$color-white: #ffffff;\n$color-black: #000000;\n\n// Primary Colors\n$color-primary-pink: #EA2466;\n$color-secondary-pink: #F5437E;\n$color-primary-dark-grey: #383838;\n$color-primary-medium-grey: #4a4a4a;\n$color-primary-light-grey: #808080;\n$color-border-primary-grey: #e2e8f0;\n// $color-border-primary-grey: #b4b4b4;\n$color-text-grey: #616161;\n\n// Background Colors\n$bg-pink-10: #FDECF2; // approximated 10% of #EA2466\n$bg-white: #FFFFFF;\n$bg-light-grey-1: #E8E8E8;\n$bg-light-grey-2: #F7F7F7;\n$bg-light-grey-3: #EDEDED;\n\n// Misc Colors\n$color-green: #00A664;\n$color-yellow: #FECE00;\n$color-red: #EB0000;\n$border-color-light-grey: #DCDCDC;\n\n// Stroke Colors\n$stroke-pink: #E11F60;\n$stroke-black: #000000;\n$stroke-dark: #1E1E1E;\n$stroke-grey: #E5E5E5;\n\n// Hover Colors\n$hover-pink: #CB104E;\n$hover-dark-grey: #484848;\n// $hover-light-grey: #EDEDED;\n\n// ====================================\n// ****** Precious Metals Theme *******\n// ====================================\n\n// Base Colors--\n$color-foreground: #252525;\n$color-primary: #030213;\n$color-secondary: #f2f1fc;\n$color-muted: #ececf0;\n$color-muted-foreground: #717182;\n$color-accent: #e9ebef;\n$color-destructive: #d4183d;\n$color-border: rgba(0, 0, 0, 0.1);\n$color-input: transparent;\n$color-input-background: #f3f3f5;\n$color-switch-background: #cbced4;\n$color-ring: #b50000;\n\n// Chart Colors--\n$chart-1: #f18b00;\n$chart-2: #3a9ac3;\n$chart-3: #6d91db;\n$chart-4: #f2ab00;\n$chart-5: #f9a800;\n\n// Gray Scale--\n$color-gray-50: #f9fafb;\n$color-gray-100: #f3f4f6;\n$color-gray-200: #e5e7eb;\n$color-gray-300: #d1d5db;\n$color-gray-400: #9ca3af;\n$color-gray-500: #6b7280;\n$color-gray-600: #4b5563;\n$color-gray-700: #374151;\n$color-gray-800: #1f2937;\n$color-gray-900: #111827;\n$color-gray-950: #030712;\n\n// Gold Colors\n$color-gold-50: #fffbeb;\n$color-gold-100: #fef3c7;\n$color-gold-200: #fde68a;\n$color-gold-300: #fcd34d;\n$color-gold-400: #fbbf24;\n$color-gold-500: #f59e0b;\n$color-gold-600: #d97706;\n$color-gold-700: #b45309;\n$color-gold-800: #92400e;\n$color-gold-900: #78350f;\n\n// Silver Colors\n$color-silver-50: #f8fafc;\n$color-silver-100: #f1f5f9;\n$color-silver-200: #e2e8f0;\n$color-silver-300: #cbd5e1;\n$color-silver-400: #94a3b8;\n$color-silver-500: #64748b;\n$color-silver-600: #475569;\n$color-silver-700: #334155;\n$color-silver-800: #1e293b;\n$color-silver-900: #0f172a;\n\n// Blue Colors\n$color-blue-50: #eff6ff;\n$color-blue-100: #dbeafe;\n$color-blue-200: #bfdbfe;\n$color-blue-300: #93c5fd;\n$color-blue-400: #60a5fa;\n$color-blue-500: #3b82f6;\n$color-blue-600: #2563eb;\n$color-blue-700: #1d4ed8;\n$color-blue-800: #1e40af;\n$color-blue-900: #1e3a8a;\n\n// Green Colors (Additional to system green)\n$color-green-50: #f0fdf4;\n$color-green-100: #dcfce7;\n$color-green-200: #bbf7d0;\n$color-green-300: #86efac;\n$color-green-400: #4ade80;\n$color-green-500: #22c55e;\n$color-green-600: #00A664;\n$color-green-700: #15803d;\n$color-green-800: #166534;\n$color-green-900: #14532d;\n\n// Red Colors (Additional to system red)\n$color-red-50: #fef2f2;\n$color-red-100: #fee2e2;\n$color-red-200: #fecaca;\n$color-red-300: #fca5a5;\n$color-red-400: #f87171;\n$color-red-500: #ef4444;\n$color-red-600: #EB0000;\n$color-red-700: #b91c1c;\n$color-red-800: #991b1b;\n$color-red-900: #7f1d1d;\n\n// Purple Colors\n$color-purple-50: #f5f3ff;\n$color-purple-100: #f3e8ff;\n$color-purple-200: #e9d5ff;\n$color-purple-300: #d8b4fe;\n$color-purple-400: #c084fc;\n$color-purple-500: #a855f7;\n$color-purple-600: #9333ea;\n$color-purple-700: #7c3aed;\n$color-purple-800: #6b21a8;\n$color-purple-900: #581c87;\n\n// Indigo Colors\n$color-indigo-50: #eef2ff;\n$color-indigo-100: #e0e7ff;\n$color-indigo-200: #c7d2fe;\n$color-indigo-300: #a5b4fc;\n$color-indigo-400: #818cf8;\n$color-indigo-500: #6366f1;\n$color-indigo-600: #4f46e5;\n$color-indigo-700: #4338ca;\n$color-indigo-800: #3730a3;\n$color-indigo-900: #312e81;\n\n// yellow Colors\n$color-yellow-50: #fefce8;\n$color-yellow-100: #fef9c3;\n$color-yellow-200: #fef08a;\n$color-yellow-300: #fde047;\n$color-yellow-400: #facc15;\n$color-yellow-500: #eab308;\n$color-yellow-600: #ca8a04;\n$color-yellow-700: #a16207;\n$color-yellow-800: #854d0e;\n$color-yellow-900: #713f12;\n\n// Orange Colors\n$color-orange-50: #fff7ed;\n$color-orange-100: #ffedd5;\n$color-orange-200: #fed7aa; \n$color-orange-300: #fdba74;\n$color-orange-400: #fb923c;\n$color-orange-500: #f97316;\n$color-orange-600: #ea580c;\n$color-orange-700: #c2410c;\n$color-orange-800: #9a3412;\n$color-orange-900: #7c2d12;\n\n// pink Colors\n$color-pink-50: #fdf2f8;\n$color-pink-100: #fce7f3;\n$color-pink-200: #fbcfe8;\n$color-pink-300: #f9a8d4;\n$color-pink-400: #f472b6;\n$color-pink-500: #ec4899;\n$color-pink-600: #db2777;\n$color-pink-700: #be185d;\n$color-pink-800: #9d174d;\n$color-pink-900: #831843;\n","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
